export const InputValidateError: React.FC<{ error?: string }> = ({ error }) => (
  <div className="invalid-feedback d-block">{error}</div>
);
